<script setup>
import { ref, computed, watch } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { useCrmEmbedTheme } from 'dashboard/composables/useCrmEmbedTheme';

const { accountId } = useAccount();
const { theme } = useCrmEmbedTheme();
const frameLoaded = ref(false);
const frameError = ref(false);

const configUrl = computed(() => {
  return `/crm/configuracoes?accountId=${accountId.value}&theme=${theme.value}`;
});

const reloadFrame = () => {
  frameLoaded.value = false;
  frameError.value = false;
  const iframe = document.querySelector('#config-ia-frame');
  if (iframe) iframe.src = configUrl.value;
};

watch(configUrl, () => {
  frameLoaded.value = false;
  frameError.value = false;
});
</script>

<template>
  <section class="flex flex-col flex-1 min-w-0 min-h-0 bg-n-surface-1">
    <div class="relative flex-1 min-h-0">
      <div
        v-if="!frameLoaded && !frameError"
        class="absolute inset-0 z-10 grid place-items-center bg-n-surface-1 text-n-slate-11"
      >
        Carregando configuracoes...
      </div>
      <div
        v-if="frameError"
        class="absolute inset-0 z-20 grid place-items-center p-6 bg-n-surface-1"
      >
        <div class="max-w-md text-center">
          <h2 class="m-0 text-lg font-semibold text-n-slate-12">
            Nao foi possivel carregar as configuracoes
          </h2>
          <p class="mt-2 mb-4 text-sm text-n-slate-11">
            Verifique se o servico esta ativo e tente recarregar.
          </p>
          <button
            type="button"
            class="inline-flex items-center h-9 px-3 text-sm font-medium rounded-lg text-white bg-n-brand hover:bg-n-brand/90"
            @click="reloadFrame"
          >
            Tentar novamente
          </button>
        </div>
      </div>
      <iframe
        id="config-ia-frame"
        :src="configUrl"
        title="Configuracoes IA"
        class="block w-full h-full border-0 bg-n-surface-1"
        @load="frameLoaded = true"
        @error="frameError = true"
      />
    </div>
  </section>
</template>
